import { query } from '../../network/fetch'
import { get } from '../../utilities'
import {
    DASHBOARD_LOAD,
    DASHBOARD_CLEAR
} from '../types.js'

const graph = {
    loadDashboard: `query {
        school {
            allow_user_invite
        }
        students(missing: true, per_page: 10) {
            data {
                id
                uuid
                semester_apa
                first_name
                last_name
                email
            }
        }
    	courses(in_session: true, per_page: 10) {
    		data {
    			id
    			uuid
    			title
    			start_time
    			end_time
    			location {
    				name
    			}
    		}
    	}
    }`
}

const state = {
    coursesInSession: [],
    studentsMissing: []
}

const getters = {
    tiles: (state, getters) => get(getters, 'user.tiles', []),
    teamTiles: (_, getters) => getters.tiles ? getters.tiles.filter((item) => item.tileable_type == "team" && item.tileable)
        .map((item) => item.tileable)
        .sort((a, b) => (a.apa < b.apa ? 1 : -1))
        : [],
    courseTiles: (_, getters) => getters.tiles ? getters.tiles.filter((item) => item.tileable_type == "course" && item.tileable)
        .map((item) => item.tileable)
        : [],
    allowUserInvite: state => state.allowUserInvite
}

const actions = {

    loadDashboard ({ commit }) {
        return new Promise((resolve) => {
            query({
                query: graph.loadDashboard,
                fetchPolicy: "network-only"
            }).then( ({ data }) => {
                commit(DASHBOARD_LOAD, data)
                resolve()
            })
        })
    }
}

const mutations = {
    [DASHBOARD_LOAD](state, data) {
        state.coursesInSession = data.courses.data
        state.studentsMissing = data.students.data
    },
    [DASHBOARD_CLEAR](state) {
        state.weeklyApaGraph = []
        state.teamApaGraph = []
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
